export default __webpack_public_path__ + "static/media/bed.e3ba17f1.svg";